import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

type UseCloseNavOnScrollOptions = {
	threshold?: number; // between 0 and 1
	rootMargin?: string; // e.g. "0px 0px -50px 0px"
};

/**
 * Closes the nav dropdown/overlay when the user scrolls such that the target element is no longer visible in the viewport.
 *
 * @param isOpen - Check if nav dropdown is currently open
 * @param onClose - Callback function to close the overlay
 * @param options - Optional configuration - { threshold?, rootMargin? }
 *
 * @example const navRef = useCloseNavOnScroll(showMenu, () => setShowMenu(false), { threshold: 0.5, rootMargin: '10px' });
 *  */
export const useCloseNavOnScroll = (isOpen: boolean, onClose: () => void, options: UseCloseNavOnScrollOptions = {}) => {
	const { ref, inView, entry } = useInView({
		...options
	});

	useEffect(() => {
		if (isOpen && !inView && entry) {
			onClose();
		}
	}, [isOpen, inView, entry, onClose]);

	return ref;
};
